import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, EnvironmentService, ResponseResult } from 'tnx-shared';
import { catchError, retry, shareReplay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BasePermissionService extends BaseService {
    entityName = 'BasePermission';
    serviceCode = 'Authorization';

    constructor(http: HttpClient, injector: Injector,
        private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
                this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    import(permissions): Promise<ResponseResult> {
        const url = `${this.serviceUri}/Import`;
        return this._http
            .post<ResponseResult>(url, permissions)
            .pipe(catchError(err => this.handleError(err, this._injector)))
            .toPromise();
    }

    getPermissionFromService(serviceEndpoint: string, ignoreBaseService: boolean): Promise<any> {
        // Todo: nếu muốn chạy trên local thì bỏ  ${serviceEndpoint.toLowerCase()}/
        const url = `${this._environmentService.getApiGateway()}/${serviceEndpoint.toLowerCase()}/api-discovery?ignoreBaseService=${ignoreBaseService}`;
        return this.defaultGet(url);
    }
}
